import { useState, useCallback } from 'react';
import { capture } from '../lib/posthog';

const KEY = 'melodiza:liked';

export function useLikedTracks() {
  const [liked, setLiked] = useState(() => {
    try {
      return new Set(JSON.parse(localStorage.getItem(KEY) || '[]'));
    } catch {
      return new Set();
    }
  });

  const toggle = useCallback((trackId) => {
    setLiked(prev => {
      const isLikedNow = prev.has(trackId);
      capture('track_liked', { trackId, action: isLikedNow ? 'unlike' : 'like' });
      const next = new Set(prev);
      if (isLikedNow) next.delete(trackId);
      else next.add(trackId);
      localStorage.setItem(KEY, JSON.stringify([...next]));
      return next;
    });
  }, []);

  const isLiked = useCallback((id) => liked.has(id), [liked]);

  return { liked, toggle, isLiked };
}
